import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RouterLink],
})
export class SidebarComponent implements OnInit {
  public currentUrl = '';
  private readonly cookiePath = environment.COOKIE_PATH;

  constructor(
    private router: Router,
    private cookieService: CookieService,
  ) {}

  ngOnInit(): void {
    this.syncCurrentUrl();
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.syncCurrentUrl());
  }

  public isMenuActive(path: string, exact = false): boolean {
    if (exact) {
      return this.currentUrl === path;
    }

    const prefix = path.endsWith('/') ? path : `${path}/`;
    return this.currentUrl === path || this.currentUrl.startsWith(prefix);
  }

  public async onClickLogout(): Promise<void> {
    const cookies: string[] = Object.keys(this.cookieService.getAll());
    for (const cookie of cookies) {
      this.cookieService.delete(cookie, this.cookiePath);
      this.cookieService.set(cookie, '', {
        expires: new Date('Thu, 01 Jan 1970 00:00:00 GMT'),
        path: this.cookiePath,
      });
    }
    this.router.navigate(['/login']);
  }

  private syncCurrentUrl(): void {
    this.currentUrl = this.router.url.split('?')[0];
  }
}
